export default __webpack_public_path__ + "6d852dbd4df86d25e4a21feada138815.svg";